var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"vueVideoPlayer"}},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":false,"options":_vm.playerOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }